<template>
  <div class="text-center">
    <v-dialog :value="pmatLoginDialog" persistent transition="dialog-bottom-transition" width="500">
      <v-card class="pa-3 pa-sm-6 dialog-select">
        <v-card-title class="pa-0 justify-end">
          <v-row no-gutters class="text-center pb-4">
            <v-col align-self="center" class="pl-9">
              <span class="title-text">ไม่สามารถเข้าสู่ระบบได้</span>
            </v-col>
            <v-col align-self="center" cols="auto"
              ><v-icon large color="text_black" @click="closeDialog"
                >mdi-close</v-icon
              ></v-col
            >
          </v-row>
        </v-card-title>
        <div class="text-center dialog-select">
          <div><v-icon color="red" class="mb-4 icon-action" style="font-size: 120px;">mdi-alert-circle</v-icon></div>
          <span class="sub-title-text">เนื่องจากคุณยังไม่ได้เป็นสมาชิกของทางสมาคมการจัดการงานบุคคลแห่งประเทศไทย (PMAT)</span>
        </div>

        <div class="pt-6 mx-sm-10 text-center dialog-select">
          <v-btn
            color="default_primary"
            class="px-2 px-sm-4"
            :width="$vuetify.breakpoint.smAndUp ? '120' : ''"
            outlined
            @click="closeDialog"
          >
            <b>ปิด</b>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PMATMemberDialogComponent',
  props: {

  },
  components: {
  },
  data () {
    return {

    }
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      pmatLoginDialog: 'pmatLoginDialog'
    })
  },
  created () {

  },
  methods: {
    closeDialog () {
      this.$store.commit('offPMATLoginDialog')
      this.goToLoginPage()
    },
    goToLoginPage () {
      this.$store.commit('logout')
      if (this.$route.name !== 'Login') {
        this.$router.push('/login')
      } else {
        window.location.reload()
      }
    }
  }
}
</script>
<style scoped>
.dialog-select {
  font-family: Noto Sans Thai !important;
}
.title-text {
  font-size: 20px;
  font-weight: 700;
  color: var(--v-header_text-base);
}
.sub-title-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--v-text_detail-base);
}
.icon-action {
  animation-name: spin;
  animation-duration: 1000ms;
}
@keyframes spin {
    from {
        transform:rotateX(180deg);
    }
    to {
        transform:rotateX(360deg);
    }
}
</style>
